import { difference, uniqBy } from 'lodash'
import { logError } from '~/Services/logError'

export function getStripePrice(product, subscriptionInterval) {
  try {
    return product.prices?.find(
      (i) => i.interval_count === subscriptionInterval
    )
  } catch (e) {
    logError(e)
    return {}
  }
}

export function getProductPriceCents(product, subscriptionInterval) {
  const price = getStripePrice(product, subscriptionInterval)
  return price?.amount || 0
}

export function getStripeProductId(product, intervalCount) {
  try {
    return product.prices.find((i) => i.interval_count === intervalCount)
      .stripe_product_id
  } catch (e) {
    logError(e)
    return null
  }
}

export function priceSumWithCoupon(cents, coupon) {
  if (!cents || !coupon) {
    return null
  }
  if (!coupon.valid) {
    return null
  }

  let price = cents
  if (coupon.percent_off) {
    price = cents - cents * (coupon.percent_off / 100)
  } else if (coupon.amount_off) {
    price = cents - coupon.amount_off
  }
  return Math.round(price)
}

function couponAppliedToProducts(couponApplied) {
  return (
    couponApplied && couponApplied.applies_to?.length && couponApplied.valid
  )
}

function getProductTests(products) {
  const tests = []
  if (products?.length) {
    products.forEach((product) => {
      if (product.biomarkers) {
        tests.push(...product.biomarkers)
      }
    })
  }
  return tests
}

export function getDuplicatedTests(products) {
  const productTests = getProductTests(products)
  if (productTests) {
    return difference(productTests, uniqBy(productTests, 'id'), 'id')
  }
  return []
}

export function getDuplicatedTestsPrice(allProducts, interval) {
  const duplicatedTests = getDuplicatedTests(allProducts)
  if (duplicatedTests?.length) {
    let sum = 0
    duplicatedTests.forEach((test) => {
      const prices = test.retail_prices
      sum += prices ? parseFloat(prices[interval]) : 0
    })
    return sum
  }
  return 0
}

export function getTotalPrice(allProducts, interval) {
  let sum = 0
  allProducts.forEach((product) => {
    const amount = getProductPriceCents(product, interval)
    sum += amount
  })
  return sum
}

export function getFinalPrice(allProducts, interval) {
  return (
    getTotalPrice(allProducts, interval) -
    getDuplicatedTestsPrice(allProducts, interval)
  )
}

export function finalPriceWithDiscount({
  allProducts,
  interval,
  couponApplied
}) {
  if (couponAppliedToProducts(couponApplied)) {
    let sum = 0
    for (let i = 0; i < allProducts.length; i++) {
      const product = allProducts[i]
      const stripePrice = getStripePrice(product, interval)
      const productHasDiscount = couponApplied.applies_to.products.find(
        (j) => j === stripePrice.stripe_product_id
      )
      if (productHasDiscount) {
        sum += priceSumWithCoupon(stripePrice.amount, couponApplied)
      } else {
        sum += stripePrice.amount
      }
    }
    return sum - getDuplicatedTestsPrice(allProducts, interval)
  }

  if (couponApplied) {
    return priceSumWithCoupon(
      getFinalPrice(allProducts, interval),
      couponApplied
    )
  }

  return getFinalPrice(allProducts, interval)
}
